<template lang="pug">
.errorMessage(v-if="this.errorMessage.length > 0")
    span.errorMessageText(v-html="this.errorMessage")
</template>
<script>

import { mapGetters, mapMutations } from "vuex";

export default {
  name: "ErrorMessage",
  computed: {
    ...mapGetters(["errorMessage"]),
  },
  methods: {
    ...mapMutations(["setErrorMessage"]),
  },
};
</script>


<style lang="scss" scoped>
.errorMessage {
  color: #b94a48;
  display: flex;
  flex-direction: column;
  border: 1px solid #eed3d7;
  border-radius: 3px;
  background-color: #f2dede;
  padding: 15px;
}
</style>